import Excel from 'exceljs';
import { saveAs } from 'file-saver';

export interface IColumns {
  header: string;
  width: number;
}

export const generateExcel = async (
  sheetName: string,
  fileName: string,
  data: Object[],
  columns: IColumns[],
  setStyle?: (workSheet: Excel.Worksheet, cells: string[]) => void,
  cells: string[] = [],
) => {
  const workbook = new Excel.Workbook();
  const workSheet = workbook.addWorksheet(sheetName);
  const newColumns: Partial<Excel.Column>[] = [];
  columns.forEach(({ header, width }, index) => {
    newColumns.push({ header, width, key: String(index) });
  });
  workSheet.columns = newColumns;
  workSheet.addRows(data);
  if (setStyle) {
    setStyle(workSheet, cells);
  }
  const buf = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buf]), `${fileName}.xlsx`);
};

export const readExcel = async (file: File) => {
  const workbook = new Excel.Workbook();
  const buf = await file.arrayBuffer();
  await workbook.xlsx.load(buf);
  return workbook;
};
